import styled from 'styled-components';

export const Column = styled.div.attrs<{
  margin?: string;
  $gap?: string;
  $alignItems?: string;
  $alignSelf?: string;
  $justifyContent?: string;
  $width?: string;
  $height?: string;
  $padding?: string;
  $maxWidth?: string;
}>(props => ({
  margin: props.margin,
  gap: props.$gap,
  height: props.$height,
  width: props.$width,
  padding: props.$padding,
  maxWidth: props.$maxWidth,
}))`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap};
  margin: ${({ margin }) => margin};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: ${({ $alignItems }) => $alignItems};
  align-self: ${({ $alignSelf }) => $alignSelf};
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  padding: ${({ $padding }) => $padding};
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

export const Row = styled.div.attrs<{
  margin?: string;
  $gap?: string;
  $alignItems?: string;
  $justifyContent?: string;
  $width?: string;
  $height?: string;
  $alignSelf?: string;
  $flexWrap?: string;
  $padding?: string;
}>(props => ({
  margin: props.margin,
  gap: props.$gap,
  alignItems: props.$alignItems,
  justifyContent: props.$justifyContent,
  width: props.$width,
  height: props.$height,
  flexWrap: props.$flexWrap,
  padding: props.$padding,
}))`
  display: flex;
  flex-direction: row;
  gap: ${({ $gap }) => $gap};
  margin: ${({ margin }) => margin};
  align-items: ${({ $alignItems }) => $alignItems};
  align-self: ${({ $alignSelf }) => $alignSelf};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  width: ${({ $width }) => $width};
  flex-wrap: ${({ $flexWrap }) => $flexWrap};
  padding: ${({ $padding }) => $padding};
`;

export const RowAlignedItems = styled(Row)<{ $alignItem?: string }>`
  align-items: ${({ $alignItems }) => $alignItems ?? 'center'};
`;

export const RowSpace = styled.div<{ $height?: string }>`
  height: ${({ $height }) => $height ?? '1rem'};
`;
export const ColumnSpace = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width ?? '1rem'};
`;

export const CenterItem = styled.div<{ $width?: string }>`
  display: grid;
  place-items: center;
  width: ${({ $width }) => $width};
`;

export const DarkSection = styled.section<{ height?: string }>`
  background-color: ${({ theme }) => theme.color.mobilityGrey};
  width: 100%;
  height: ${({ height }) => height ?? '100vh'};
`;

export const WhiteSection = styled.div`
  background-color: ${({ theme }) => theme.color.pureWhite};
`;

export const LightGreySection = styled.div`
  background-color: ${({ theme }) => theme.color.lightGrey2};
`;

export const CustomSection = styled.div<{ $color?: string }>`
  background-color: ${({ theme, $color }) => $color || theme.color.white};
`;

export const SectionRoot = styled.div`
  padding: 7.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    padding: 4rem 2rem;
  }
`;
